
import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class QuotaTypeSelect extends Vue {
  @Prop({ required: true }) value: number | null;
  @Prop({ default: false }) disabled: boolean;

  get selectedQuotaType(): number | null {
    return this.value;
  }

  set selectedQuotaType(val: number | null) {
    this.$emit("input", val);
  }

  get quotaTypes() {
    return [
      { text: this.$i18n.translate("transportationPermission.quotaTypes.trips", "Trips"), value: 0 },
      { text: this.$i18n.translate("transportationPermission.quotaTypes.distance", "Distance"), value: 1 },
      { text: this.$i18n.translate("transportationPermission.quotaTypes.currency", "Currency" ), value: 2 },
    ];
  }
}
